{
  "title": "Класи",
  "description": "Групи учнів разом з їхніми вчителями.",
  "searchPlaceholder": "Пошук класів…",
  "filter": {
    "label": "Показати",
    "active": "Активні",
    "archived": "Архівні",
    "all": "Усі",
    "yearLabel": "Навчальний рік",
    "currentYear": "Поточний рік ({{name}})",
    "currentYearPlain": "Поточний рік",
    "allYears": "Усі роки"
  },
  "table": {
    "name": "Назва",
    "teachers": "Вчителі",
    "pupils": "Учні",
    "status": "Статус"
  },
  "status": {
    "active": "Активний",
    "archived": "В архіві"
  },
  "noTeachers": "Ще немає вчителів",
  "teachers": {
    "manage": "Керувати",
    "title": "Вчителі класу",
    "description": "Оберіть працівників школи, які ведуть заняття в цьому класі.",
    "noStaff": "Немає активних працівників — спершу запросіть їх.",
    "save": "Зберегти вчителів",
    "success": "Список вчителів оновлено"
  },
  "lessonsLink": "Уроки",
  "empty": {
    "title": "Ще немає класів",
    "manageText": "Створіть перший клас, щоб почати запис учнів.",
    "pupilText": "Ви ще не приєдналися до жодного класу.",
    "filterText": "За цими фільтрами нічого не знайдено."
  },
  "create": {
    "button": "Створити клас",
    "title": "Новий клас",
    "description": "Дайте класу назву — учнів можна записати одразу після цього.",
    "name": "Назва класу",
    "namePlaceholder": "6-А Інформатика (гр2)",
    "nameHint": "Когорта → предмет → підгрупа: «6-А Інформатика (гр2)». Без поділу на підгрупи — просто «6-А Інформатика». Однаковий порядок тримає класи однієї паралелі поруч у списку.",
    "descriptionLabel": "Опис",
    "descriptionPlaceholder": "Необов'язково — про що цей клас",
    "submit": "Створити клас",
    "submitting": "Створюємо…",
    "success": "Клас створено",
    "failed": "Не вдалося створити клас",
    "yearLabel": "Навчальний рік",
    "yearPlaceholder": "Оберіть рік",
    "yearCurrent": "поточний"
  },
  "edit": {
    "button": "Редагувати клас",
    "title": "Редагування класу",
    "description": "Змініть назву класу або його опис.",
    "submit": "Зберегти зміни",
    "submitting": "Зберігаємо…",
    "success": "Клас оновлено",
    "failed": "Не вдалося зберегти зміни"
  },
  "validation": {
    "nameRequired": "Вкажіть назву класу",
    "codeRequired": "Введіть код приєднання",
    "pupilRequired": "Оберіть учня"
  },
  "detail": {
    "back": "До списку класів",
    "teachers": "Вчителі",
    "roster": "Склад класу",
    "rosterCount_one": "Записано {{count}} учня",
    "rosterCount_few": "Записано {{count}} учнів",
    "rosterCount_many": "Записано {{count}} учнів",
    "rosterCount_other": "Записано {{count}} учнів",
    "noDescription": "Без опису",
    "archivedNotice": "Клас в архіві — активність зупинено, але всі дані доступні для перегляду."
  },
  "roster": {
    "empty": "У класі ще немає учнів.",
    "enroll": "Записати учня",
    "enrollTitle": "Запис учня",
    "enrollDescription": "Оберіть учня цієї школи, щоб додати його до класу.",
    "pupil": "Учень",
    "pupilPlaceholder": "Оберіть учня",
    "noPupils": "Немає учнів, яких можна записати — спершу запросіть їх.",
    "enrollSubmit": "Записати",
    "enrollSuccess": "Учня записано до класу",
    "unenroll": "Відрахувати",
    "unenrollTitle": "Відрахувати {{name}}?",
    "unenrollDescription": "Учень покине цей клас, але його історія збережеться.",
    "unenrollSuccess": "Учня відраховано з класу",
    "table": {
      "name": "Ім'я",
      "email": "Ел. пошта",
      "status": "Статус"
    },
    "active": "Активний",
    "inactive": "Неактивний"
  },
  "joinCode": {
    "title": "Код приєднання",
    "description": "Учні вводять цей код (або відкривають посилання), щоб самостійно приєднатися до класу.",
    "reveal": "Показати код",
    "revealing": "Завантажуємо код…",
    "enabled": "Увімкнено",
    "disabled": "Вимкнено",
    "copyCode": "Копіювати код",
    "copyLink": "Копіювати посилання",
    "copiedCode": "Код скопійовано",
    "copiedLink": "Посилання скопійовано",
    "copyFailed": "Не вдалося скопіювати — скопіюйте вручну",
    "rotate": "Змінити код",
    "rotateTitle": "Змінити код приєднання?",
    "rotateDescription": "Поточний код і посилання одразу перестануть діяти.",
    "rotated": "Код приєднання змінено",
    "enable": "Увімкнути",
    "disable": "Вимкнути",
    "enabledToast": "Код приєднання увімкнено",
    "disabledToast": "Код приєднання вимкнено"
  },
  "archive": {
    "button": "Архівувати клас",
    "title": "Архівувати {{name}}?",
    "description": "Активність зупиниться, але всі дані залишаться доступними для перегляду. Клас можна буде повернути з архіву.",
    "success": "Клас архівовано"
  },
  "unarchive": {
    "button": "Повернути з архіву",
    "success": "Клас повернуто з архіву"
  },
  "join": {
    "title": "Приєднатися до класу",
    "description": "Введіть код, який вам надав учитель.",
    "codeLabel": "Код приєднання",
    "codePlaceholder": "напр. ABCD2345",
    "submit": "Приєднатися",
    "submitting": "Приєднуємось…",
    "success": "Вітаємо у класі «{{name}}»!",
    "failed": "Не вдалося приєднатися до класу",
    "backToDashboard": "На головну"
  },
  "promote": {
    "button": "Перевести в наступний рік",
    "title": "Перевести {{name}}",
    "description": "Створює клас в іншому навчальному році: вчителі переносяться автоматично, склад — лише за вашим вибором, код приєднання — ніколи. Оцінки та історія залишаються в цьому класі.",
    "yearLabel": "Цільовий рік",
    "yearPlaceholder": "Оберіть рік",
    "noYears": "Немає інших навчальних років — спершу додайте наступний рік у Налаштуваннях.",
    "nameLabel": "Назва нового класу",
    "carryRoster": "Перенести склад класу",
    "carryRosterNote": "Записує всіх активних учнів до нового класу.",
    "archiveSource": "Архівувати цей клас",
    "archiveSourceNote": "Активність тут завершується; все залишається доступним для перегляду.",
    "validation": "Спершу оберіть цільовий рік",
    "success": "{{name}} створено",
    "submit": "Перевести"
  }
}
